import { Injectable } from '@angular/core';
import { AppService } from '../../../../../core/service/Base.Service';


@Injectable()
export class CountryService extends AppService<any> {

    constructor() {
        super('Country');
    }
    async getCountry() {
        const result = await this.get('');
        return result;

    }

    async getCountryByCode(countrycode: any) {
        const result = await this.get('Country', countrycode);
        return result;
    }
}





// WEBPACK FOOTER //
// ./src/app/shell/forms/organizational-setup/setup/Country/Country.service.ts